import { ActionTree } from 'vuex';
import { UserState } from "./types";
import { RootState } from "@/store/types"
import { InfoItem } from '@/common/acl';

export  const actions: ActionTree<UserState, RootState> = {

    setTest(context, payload: string) {
        context.commit("setTest", payload)
    },

}